

export let accessToken: string | null = null;

export type LoginRespData = {
    firstname: string;
    lastname: string;
    role: string;
    email: string;
    access_token: string;
    id: string;
};

export const getAccessToken = () => {
    if (!accessToken) {
        accessToken = localStorage.getItem('accessToken') || null;
    }
    return accessToken;
};

/** Decode JWT payload without verifying signature (client-side expiry check only). */
export const decodeTokenPayload = (token: string): { expires?: number; user_id?: string | number } | null => {
    try {
        const parts = token.split('.');
        if (parts.length < 2) return null;
        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const json = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(json);
    } catch {
        return null;
    }
};

export const isAccessTokenValid = (): boolean => {
    const token = getAccessToken();
    if (!token) return false;
    const payload = decodeTokenPayload(token);
    if (!payload || payload.expires == null) return false;
    return Number(payload.expires) >= Date.now() / 1000;
};

export const login = (data: LoginRespData, access_token: string ) => {
    localStorage.setItem('userName', `${data.lastname}, ${data.firstname}`);
    localStorage.setItem('email', `${data.email}`);
    localStorage.setItem('role', data.role);
    localStorage.setItem('accessToken', access_token);
    localStorage.setItem('userid', data.id);
    accessToken = access_token;
};

export const logout = () => {
    accessToken = null;
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userName');
    localStorage.removeItem('role');
    localStorage.removeItem('email');
    localStorage.removeItem('userid');
};

/** Clear session and send user to login when token is missing/expired or API rejects auth. */
export const handleUnauthorized = () => {
    logout();
    if (typeof window !== 'undefined' && !window.location.pathname.includes('/login')) {
        window.location.href = '/login';
    }
};
